export const environment = {
  production: true,
  APIEndpoint: 'https://api.laporrabcn.com/v1',
  Amplitude: {
    APIKey: '61d9a81133e173c0a44c24669de50da6',
  },
};
